import React from 'react';
import config from '../../../config';

let IS_FIRST_MOUNT_AFTER_LOAD = !!config.useSSR; //SSR

export default function connectDataFetchers(Component, actionCreators) {
    return class DataFetchersWrapper extends React.Component {

        static fetchData({ dispatch, params = {}, query = {} }) {
            return Promise.all(
                actionCreators.map(actionCreator => dispatch(actionCreator(params, query)))
            );
        }

        componentDidUpdate(prevProps) {
            const { location } = this.props;
            const { location: prevLocation } = prevProps;

            const isUrlChanged = (location.pathname !== prevLocation.pathname)
                              || (location.query !== prevLocation.query);

            if (isUrlChanged) {
                this._fetchDataOnClient();
            }
        }

        componentDidMount() {
            if (!IS_FIRST_MOUNT_AFTER_LOAD) {
                this._fetchDataOnClient();
            }

            IS_FIRST_MOUNT_AFTER_LOAD = false;
        }


        _fetchDataOnClient() {

            DataFetchersWrapper.fetchData({
                dispatch : this.props.dispatch,
                params   : this.props.params,
                query    : this.props.location.query
            });
        }

        render() {
            return (
                <Component {...this.props} />
            );
        }
    };
}
